const theme = {
  colors: {
    primary: '#2E5984', // Deep blue - primary brand color
    secondary: '#683c4a', // Tandara color - secondary brand color
    accent: '#F5A623', // Gold/yellow - accent color
    text: '#333333', // Dark gray for text
    lightText: '#666666', // Lighter gray for secondary text
    background: '#FFFFFF', // White background
    lightBackground: '#F5F7FA', // Light gray background for sections
    border: '#E1E4E8', // Light gray for borders
    success: '#28A745', // Green for success messages
    error: '#DC3545', // Red for error messages
    warning: '#FFC107', // Yellow for warning messages
    info: '#17A2B8', // Teal for info messages
  },
  fonts: {
    primary: '"Roboto", sans-serif',
    heading: '"Montserrat", sans-serif',
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    round: '50%',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    short: '0.3s ease',
    medium: '0.5s ease',
    long: '0.7s ease',
  },
};

export default theme;
